import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { LOGIN } from "../../redux/constants";

const PaymentFail = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.auth);
  const dispatch = useDispatch(); 

  useEffect(() => {
      setTimeout(() => {
          navigate("/onboard", { state: { payment: "fail"} });
      }, 2000);

      let authUser = { ...userData };
      authUser.is_subscribed = false;
      authUser.is_board_complete = true;
      dispatch({ type: LOGIN, payload: authUser });
      localStorage.setItem("user", JSON.stringify(authUser));
  }, []);

  return (
    <div className="w-screen h-screen">
      <div className="h-screen flex items-center justify-center flex-col py-8">
        <div className="w-20 h-20 rounded-full bg-rose-600 text-white flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div className="font-md font-inter font-semibold py-3">Payment Failed.</div>
      </div>
    </div>
  );
};

export default PaymentFail;
